'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import StoreManagerDashboard from './dashboards/StoreManagerDashboard';
import QHSEManagerDashboard from './dashboards/QHSEManagerDashboard';
import CompanyAdminDashboard from './dashboards/CompanyAdminDashboard';
import StoreOperatorDashboard from './dashboards/StoreOperatorDashboard';
import AuditorDashboard from './dashboards/AuditorDashboard';
import SuperAdminDashboard from './dashboards/SuperAdminDashboard';

const ROLES = [
  { id: 'store-manager', label: 'Store Manager', initials: 'SM', color: 'bg-blue-600' },
  { id: 'qhse-manager', label: 'QHSE Manager', initials: 'QM', color: 'bg-teal-600' },
  { id: 'company-admin', label: 'Company Admin', initials: 'CA', color: 'bg-violet-600' },
  { id: 'store-operator', label: 'Store Operator', initials: 'SO', color: 'bg-orange-500' },
  { id: 'auditor', label: 'Read-Only (Auditor)', initials: 'RO', color: 'bg-slate-500' },
  { id: 'super-admin', label: 'Super Admin', initials: 'SA', color: 'bg-rose-600' },
];

export default function DashboardContent() {
  const [activeRole, setActiveRole] = useState('store-manager');
  const [roleDropOpen, setRoleDropOpen] = useState(false);

  const currentRole = ROLES?.find((r) => r?.id === activeRole) ?? ROLES?.[0];

  const renderDashboard = () => {
    switch (activeRole) {
      case 'store-manager': return <StoreManagerDashboard />;
      case 'qhse-manager': return <QHSEManagerDashboard />;
      case 'company-admin': return <CompanyAdminDashboard />;
      case 'store-operator': return <StoreOperatorDashboard />;
      case 'auditor': return <AuditorDashboard />;
      case 'super-admin': return <SuperAdminDashboard />;
      default: return <StoreManagerDashboard />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Role switcher bar */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-700 text-foreground tracking-tight">Dashboard</h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            29 Jul 2026 · Live data
          </p>
        </div>
        <div className="relative">
          <button
            onClick={() => setRoleDropOpen((p) => !p)}
            className="flex items-center gap-2.5 px-4 py-2.5 bg-card border border-border rounded-xl text-sm font-500 hover:border-secondary transition-all shadow-card"
          >
            <div className={`w-6 h-6 rounded-full ${currentRole?.color} text-white text-[10px] font-700 flex items-center justify-center`}>
              {currentRole?.initials}
            </div>
            <span>Viewing as: <span className="font-600 text-foreground">{currentRole?.label}</span></span>
            <Icon name="ChevronDownIcon" size={14} className="text-muted-foreground" />
          </button>
          {roleDropOpen && (
            <div className="absolute right-0 top-full mt-2 w-56 bg-card border border-border rounded-xl shadow-dropdown z-20 fade-in overflow-hidden">
              {ROLES?.map((r) => (
                <button
                  key={r?.id}
                  onClick={() => { setActiveRole(r?.id); setRoleDropOpen(false); }}
                  className={`flex items-center gap-3 w-full px-4 py-2.5 text-sm transition-colors hover:bg-muted text-left ${r?.id === activeRole ? 'bg-primary/5 font-600 text-primary' : 'text-foreground'}`}
                >
                  <div className={`w-6 h-6 rounded-full ${r?.color} text-white text-[10px] font-700 flex items-center justify-center shrink-0`}>
                    {r?.initials}
                  </div>
                  {r?.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      {renderDashboard()}
    </div>
  );
}